export { default as FiltersBlock } from './FiltersBlock/FiltersBlock';
export { default as TariffsBlock } from './TariffsBlock/TariffsBlock';
export { default as SearchResult } from './SearchResult/SearchResult';
export { default as FindBundle } from './FindBundle/FindBundle';
export { default as SingleTariffsContent } from './SingleTariffsContent/SingleTariffsContent';
export { default as SingleTariffsTabs } from './SingleTariffsTabs/SingleTariffsTabs';
export { default as InternetBlock } from './InternetBlock/InternetBlock';
